import { useState, useEffect } from 'react';
import { premiumVideos } from '../core/arrayVideos';
import fetchPartnersData from '../core/fetchPartners';

const useVideosArrayPremium = () => {
  const [partners, setPartners] = useState([]);

  useEffect(() => {
    function fetchData() {
      fetchPartnersData().then((partners) => setPartners(partners));
    }
    fetchData();
  }, []);

  return premiumVideos.map((video) => {
    const [partner] = partners.filter((partner) =>
      (partner.artisticName || '')
        .toLowerCase()
        .match(video.partnerName.toLowerCase())
    );
    return { ...video, partner };
  });
};

export default useVideosArrayPremium;
